import { render, staticRenderFns } from "./AccessWalletLayout.vue?vue&type=template&id=e5913a38&scoped=true&"
import script from "./AccessWalletLayout.vue?vue&type=script&lang=js&"
export * from "./AccessWalletLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletLayout.vue?vue&type=style&index=0&id=e5913a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5913a38",
  null
  
)

export default component.exports